// WP-0.7: TanStack Query client (§16.3 locked). Conservative defaults; per-feature
// queries tune their own staleness in later WPs.
import { QueryClient } from '@tanstack/react-query';

export function makeQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
    },
  });
}
